import BoardContainer from "./BoardContainer";

export default BoardContainer;
